<template>
  <v-dialog v-model="show_detial" max-width="800px">
    <v-card>
      <v-card-title primary-title>
        <v-flex md11>
          <span class="red--text caption">
            <span>{{ labels.warn }}</span>
          </span>
        </v-flex>
        <v-flex md1>
          <v-icon x-large v-on:click="exportPDF(detial_info.CourseNo,detial_info.Semester)"
            >print</v-icon
          >
        </v-flex>
        <v-flex md12>
          <span class="headline">{{ labels.course_info }}</span>
        </v-flex>
      </v-card-title>
      <v-container fluid grid-list-lg py-1>
        <v-layout row wrap>
          <v-flex md6 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3 class="detial_title">{{ labels.semester }}</h3>
                {{ detial_info.Semester }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md6 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3 class="detial_title">{{ labels.course_code }}</h3>
                {{ detial_info.CourseNo }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md6 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3 class="detial_title">{{ labels.course_title }}</h3>
                {{ detial_info.CourseName }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md6 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3 class="detial_title">{{ labels.instructor }}</h3>
                {{ detial_info.CourseTeacher }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md6 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3 class="detial_title">{{ labels.credits }}</h3>
                {{ detial_info.CreditPoint }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md6 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3 class="detial_title">{{ labels.lecture_intern_hourse }}</h3>
                {{ detial_info.CourseTimes }} / {{ detial_info.PracticalTimes }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md6 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3 class="detial_title">{{ labels.required_elective }}</h3>
                {{ detial_info.RequireOption }} / {{ detial_info.AllYear }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md6 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3 class="detial_title">{{ labels.total_registered }}</h3>
                {{ detial_info.AllStudent }} ({{ detial_info.ChooseStudent }} /
                {{ detial_info.ThreeStudent }})
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md12 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3>{{ labels.mix_class }}</h3>
                <span
                  >{{ labels.total_registered_mix }}：{{
                    MergeCourse.total
                  }}</span
                >
                <div v-for="(item, index) in MergeCourse.course" :key="index">
                    <span>
                        {{ labels.course_code }}：{{ item.CourseNo }}
                        {{ labels.total_registered }}：{{ item.AllStudent }} ({{ item.ChooseStudent }} /{{ item.ThreeStudent }})
                    </span>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md12 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3>選課人數上限</h3>
                <div>
                  <span>
                    {{ labels.maxi_capacity_for_ntust_preregistration }}：{{
                      detial_info.Restrict1
                    }}
                  </span>
                  <br />
                  <span>
                    {{ labels.maxi_capacity_for_ntust_add_drop }}：{{
                      detial_info.Restrict2
                    }}
                  </span>
                  <br />
                  <span>
                    {{ labels.maxi_capacity_for_ntu_system }}：{{
                      detial_info.Restrict3
                    }}
                  </span>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md12 py-1 v-if="LimitOnTheNumber.Display">
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3>學制科系人數限制</h3>
                <div
                  v-for="(item, index) in LimitOnTheNumber.Result"
                  :key="index"
                >
                  <span>
                    {{ item.DepartmentAliase }} {{ item.Persons }}/{{
                      item.Restrict
                    }}
                  </span>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md12 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3 class="detial_title">{{ labels.prerequisites }}</h3>
                {{ detial_info.PreCourse }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md12 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3 class="detial_title">{{ labels.time_location }}</h3>
                {{ detial_info.ClassRoomNo }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md12 py-1>
            <v-card color="grey lighten-5">
              <v-card-text>
                <h3 class="detial_title">
                  {{ labels.core_professional_competencies }}
                </h3>
                {{ detial_info.CoreAbility }}
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-title primary-title>
        <h3 class="headline">{{ labels.course_content }}</h3>
      </v-card-title>
      <v-container fluid grid-list-lg py-1>
          <v-layout row wrap>
              <v-flex md12>
                  <v-card color="grey lighten-5">
                      <v-card-text>
                          <h3>{{ labels.course_website }}</h3>
                          <a :href="detial_info.CourseURL" target="_blank">
                              {{ detial_info.CourseURL }}
                          </a>
                      </v-card-text>
                  </v-card>
              </v-flex>
              <v-flex md12>
                  <v-card color="grey lighten-5">
                      <v-card-text>
                          <h3 py-2>{{ labels.course_objectives }}</h3>
                          <span>{{ detial_info.CourseObject }}</span>
                      </v-card-text>
                  </v-card>
              </v-flex>
              <v-flex md12>
                  <v-card color="grey lighten-5">
                      <v-card-text>
                          <h3>{{ labels.outline_of_lectures }}</h3>
                          <span style="white-space: pre-wrap">{{ detial_info.CourseContent }}</span>
                      </v-card-text>
                  </v-card>
              </v-flex>
              <v-flex md12>
                  <v-card color="grey lighten-5">
                      <v-card-text>
                          <h3>{{ labels.instruction }}</h3>
                          <span>講授 Lecture：{{ detial_info.Instruction_1 }}%</span><br>
                          <span>分組討論 Group discussion：{{ detial_info.Instruction_2 }}%</span><br>
                          <span>案例研討 Case study：{{ detial_info.Instruction_3 }}%</span><br>
                          <span>操作練習 Practical exercises：{{ detial_info.Instruction_4 }}%</span><br>
                          <span>其他 Others：{{ detial_info.Instruction_other }}</span>
                      </v-card-text>
                  </v-card>
              </v-flex>
              <v-flex md12>
                  <v-card color="grey lighten-5">
                      <v-card-text>
                          <h3>{{ labels.textbooks }}</h3>
                          <span style="white-space: pre-wrap">{{ detial_info.CourseTextbook }}</span>
                      </v-card-text>
                  </v-card>
              </v-flex>

              <v-flex md12>
                  <v-card color="grey lighten-5">
                      <v-card-text>
                          <h3>{{ labels.references }}</h3>
                          <span>{{ detial_info.CourseRefbook }}</span>
                      </v-card-text>
                  </v-card>
              </v-flex>
              <v-flex md12>
                  <v-card color="grey lighten-5">
                      <v-card-text>
                          <h3>{{ labels.notice }}</h3>
                          <span>{{ detial_info.CourseNote }}</span>
                      </v-card-text>
                  </v-card>
              </v-flex>
              <v-flex md12>
                  <v-card color="grey lighten-5">
                      <v-card-text>
                          <h3>{{ labels.grading }}</h3>
                          <span>{{ detial_info.CourseGrading }}</span>
                      </v-card-text>
                  </v-card>
              </v-flex>
              <v-flex md12>
                  <v-card color="grey lighten-5">
                      <v-card-text>
                          <h3>{{ labels.notes }}</h3>
                          <span>{{ detial_info.CourseRemark }}</span>
                      </v-card-text>
                  </v-card>
              </v-flex>
          </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat v-on:click="show_detial = false">{{ labels.close }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import languages from "../languages/CourseDetial.json";

export default {
  data: () => ({
    labels: {
      warn: "",
      course_info: "",
      semester: "",
      course_code: "",
      course_title: "",
      instructor: "",
      credits: "",
      lecture_intern_hourse: "",
      required_elective: "",
      total_registered: "",
      mix_class: "",
      total_registered_mix: "",
      registered: "",
      maxi_capacity_for_ntust_preregistration: "",
      maxi_capacity_for_ntust_add_drop: "",
      maxi_capacity_for_ntu_system: "",
      prerequisites: "",
      time_location: "",
      core_professional_competencies: "",
      course_content: "",
      course_website: "",
      course_objectives: "",
      outline_of_lectures: "",
      textbooks: "",
      references: "",
      notice: "",
      instruction:"",
      grading: "",
      notes: "",
      close: "",
    },
  }),
  computed: {
    show_detial: {
      get() {
        return this.$store.state.show_detial;
      },
      set(value) {
        this.$store.commit("setShowDetial", value);
      },
    },
    detial_info() {
      return this.$store.state.detial_info;
    },
    LimitOnTheNumber() {
      return this.$store.state.LimitOnTheNumber;
    },
    MergeCourse() {
      return this.$store.state.MergeCourse;
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
  },
  methods: {
    exportPDF: function (course_no,Semester) {
      this.$store.dispatch("exportCourseDetialPDF", {courseNo:course_no, Semester:Semester});
    },
    setLanguage: function (select_language) {
      this.labels.warn = languages.warn[select_language.lang];
      this.labels.course_info = languages.course_info[select_language.lang];
      this.labels.semester = languages.semester[select_language.lang];
      this.labels.course_code = languages.course_code[select_language.lang];
      this.labels.course_title = languages.course_title[select_language.lang];
      this.labels.instructor = languages.instructor[select_language.lang];
      this.labels.credits = languages.credits[select_language.lang];
      this.labels.lecture_intern_hourse =
        languages.lecture_intern_hourse[select_language.lang];
      this.labels.required_elective =
        languages.required_elective[select_language.lang];
      this.labels.total_registered =
        languages.total_registered[select_language.lang];
      this.labels.mix_class = languages.mix_class[select_language.lang];
      this.labels.total_registered_mix =
        languages.total_registered_mix[select_language.lang];
      this.labels.registered = languages.registered[select_language.lang];
      this.labels.maxi_capacity_for_ntust_preregistration =
        languages.maxi_capacity_for_ntust_preregistration[select_language.lang];
      this.labels.maxi_capacity_for_ntust_add_drop =
        languages.maxi_capacity_for_ntust_add_drop[select_language.lang];
      this.labels.maxi_capacity_for_ntu_system =
        languages.maxi_capacity_for_ntu_system[select_language.lang];
      this.labels.prerequisites = languages.prerequisites[select_language.lang];
      this.labels.time_location = languages.time_location[select_language.lang];
      this.labels.core_professional_competencies =
        languages.core_professional_competencies[select_language.lang];
      this.labels.course_content =
        languages.course_content[select_language.lang];
      this.labels.course_website =
        languages.course_website[select_language.lang];
      this.labels.course_objectives =
        languages.course_objectives[select_language.lang];
      this.labels.outline_of_lectures =
        languages.outline_of_lectures[select_language.lang];
      this.labels.textbooks = languages.textbooks[select_language.lang];
      this.labels.references = languages.references[select_language.lang];
      this.labels.notice = languages.notice[select_language.lang];
      this.labels.grading = languages.grading[select_language.lang];
      this.labels.notes = languages.notes[select_language.lang];
        this.labels.close = languages.close[select_language.lang];
        this.labels.instruction = languages.instruction[select_language.lang];
    },
  },
};
</script>

<style>
.detial_title {
  display: inline;
}
</style>
